import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const IssueStatusDoneIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m4.101 5.101a.85.85 0 1 0-1.202-1.202L6.5 9.298 5.101 7.899a.85.85 0 1 0-1.202 1.202l2 2a.85.85 0 0 0 1.202 0z"
				clipRule="evenodd"
			></path>
		</svg>
	),
)
